// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-already-submitted-header {
    margin-top: 159px;
    margin-left: 37px;
    margin-right: 38px;
}

.lr-already-submitted-primary {
    margin-top: 39px;
    margin-left: 37px;
    margin-right: 37px;
}

.lr-already-submitted-secondary {
    margin-left: 47px;
    margin-right: 48px;
    margin-top: -10px; /* Move the text up by reducing the margin */
}

.loader-container {
    display: flex; /* Use flexbox for vertical and horizontal alignment */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    height: 200px; /* Set a fixed height for the container */
    width: 100%; /* Ensure the container spans the full width */
    transform-origin: center; /* Ensure scaling happens from the center */
}

/* Default scale for larger screens */
.loader-container {
    transform: scale(1.15); /* Fixed smaller scale for larger screens */
}

/* Adjustments for smaller screens */
@media screen and (max-width: 768px) {
    .loader-container {
        transform: scale(1.15); /* Larger scale for smaller screens */
        height: 200px; /* Adjust height for smaller screens */
    }
}

/* Adjustments for medium screens (e.g., tablets) */
@media screen and (min-width: 769px) and (max-width: 1024px) {
    .loader-container {
        transform: scale(1.15); /* Medium scale for tablets */
        height: 200px; /* Adjust height for tablets */
    }
}

.loader {
  width: 80px;
  height: 80px;
}
.loader circle {
  fill: transparent;
  stroke: #e1261c;
  stroke-width: 8;                        /* width x .1 */
  stroke-dasharray: 251.33;               /* width x pi */
  transform-origin: 40px 40px 0;          /* width x .5, width x .5, 0 */
  animation: loader 2s linear infinite;
}
@keyframes loader {
  0% {
      transform: rotate(-90deg);
      stroke-dashoffset: 62.83;        /* .25 x pi x width */
  }
  16.67% {
      transform: rotate(27deg);
      stroke-dashoffset: 50.27;        /* .20 x pi x width */
  }
  33.33% {
      transform: rotate(153deg);
      stroke-dashoffset: 75.40;        /* .30 x pi x width */
  }
  58.33% {
      transform: rotate(320deg);
      stroke-dashoffset: 138.23;       /* .55 x pi x width */
  }
  66.67% {
      transform: rotate(385deg);
      stroke-dashoffset: 138.23;       /* .55 x pi x width */
  }
  83.33% {
      transform: rotate(516deg);
      stroke-dashoffset: 113.10;       /* .45 x pi x width */
  }
  100% {
      transform: rotate(630deg);
      stroke-dashoffset: 62.83;        /* .25 x pi x width */
  }
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/error-pages/claim-already-submitted/claim-already-submitted.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB,EAAE,4CAA4C;AACnE;;AAEA;IACI,aAAa,EAAE,sDAAsD;IACrE,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,aAAa,EAAE,yCAAyC;IACxD,WAAW,EAAE,8CAA8C;IAC3D,wBAAwB,EAAE,2CAA2C;AACzE;;AAEA,qCAAqC;AACrC;IACI,sBAAsB,EAAE,2CAA2C;AACvE;;AAEA,oCAAoC;AACpC;IACI;QACI,sBAAsB,EAAE,qCAAqC;QAC7D,aAAa,EAAE,sCAAsC;IACzD;AACJ;;AAEA,mDAAmD;AACnD;IACI;QACI,sBAAsB,EAAE,6BAA6B;QACrD,aAAa,EAAE,8BAA8B;IACjD;AACJ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe,yBAAyB,eAAe;EACvD,wBAAwB,gBAAgB,eAAe;EACvD,6BAA6B,WAAW,8BAA8B;EACtE,oCAAoC;AACtC;AACA;EACE;MACI,yBAAyB;MACzB,wBAAwB,SAAS,qBAAqB;EAC1D;EACA;MACI,wBAAwB;MACxB,wBAAwB,SAAS,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,wBAAwB,SAAS,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,yBAAyB,QAAQ,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,yBAAyB,QAAQ,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,yBAAyB,QAAQ,qBAAqB;EAC1D;EACA;MACI,yBAAyB;MACzB,wBAAwB,SAAS,qBAAqB;EAC1D;AACF","sourcesContent":[".lr-already-submitted-header {\n    margin-top: 159px;\n    margin-left: 37px;\n    margin-right: 38px;\n}\n\n.lr-already-submitted-primary {\n    margin-top: 39px;\n    margin-left: 37px;\n    margin-right: 37px;\n}\n\n.lr-already-submitted-secondary {\n    margin-left: 47px;\n    margin-right: 48px;\n    margin-top: -10px; /* Move the text up by reducing the margin */\n}\n\n.loader-container {\n    display: flex; /* Use flexbox for vertical and horizontal alignment */\n    justify-content: center; /* Center horizontally */\n    align-items: center; /* Center vertically */\n    height: 200px; /* Set a fixed height for the container */\n    width: 100%; /* Ensure the container spans the full width */\n    transform-origin: center; /* Ensure scaling happens from the center */\n}\n\n/* Default scale for larger screens */\n.loader-container {\n    transform: scale(1.15); /* Fixed smaller scale for larger screens */\n}\n\n/* Adjustments for smaller screens */\n@media screen and (max-width: 768px) {\n    .loader-container {\n        transform: scale(1.15); /* Larger scale for smaller screens */\n        height: 200px; /* Adjust height for smaller screens */\n    }\n}\n\n/* Adjustments for medium screens (e.g., tablets) */\n@media screen and (min-width: 769px) and (max-width: 1024px) {\n    .loader-container {\n        transform: scale(1.15); /* Medium scale for tablets */\n        height: 200px; /* Adjust height for tablets */\n    }\n}\n\n.loader {\n  width: 80px;\n  height: 80px;\n}\n.loader circle {\n  fill: transparent;\n  stroke: #e1261c;\n  stroke-width: 8;                        /* width x .1 */\n  stroke-dasharray: 251.33;               /* width x pi */\n  transform-origin: 40px 40px 0;          /* width x .5, width x .5, 0 */\n  animation: loader 2s linear infinite;\n}\n@keyframes loader {\n  0% {\n      transform: rotate(-90deg);\n      stroke-dashoffset: 62.83;        /* .25 x pi x width */\n  }\n  16.67% {\n      transform: rotate(27deg);\n      stroke-dashoffset: 50.27;        /* .20 x pi x width */\n  }\n  33.33% {\n      transform: rotate(153deg);\n      stroke-dashoffset: 75.40;        /* .30 x pi x width */\n  }\n  58.33% {\n      transform: rotate(320deg);\n      stroke-dashoffset: 138.23;       /* .55 x pi x width */\n  }\n  66.67% {\n      transform: rotate(385deg);\n      stroke-dashoffset: 138.23;       /* .55 x pi x width */\n  }\n  83.33% {\n      transform: rotate(516deg);\n      stroke-dashoffset: 113.10;       /* .45 x pi x width */\n  }\n  100% {\n      transform: rotate(630deg);\n      stroke-dashoffset: 62.83;        /* .25 x pi x width */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
